module.exports = __webpack_public_path__ + "static/media/main-logo.39052fab.svg";